import { HeartHandshake, Leaf, ShieldCheck, Users, Scale } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SUSTAINABILITY_PILLARS } from "../data/content";

const icons = [ShieldCheck, Leaf, Users, Scale, HeartHandshake];

export default function Sustainability() {
  return (
    <main data-testid="sustainability-page" className="bg-[#070C14] text-white">
      <PageHero
        testId="sustainability-hero"
        eyebrow="Sustainability & CSR"
        title="Responsible energy work, measured beyond the site boundary."
        description="Clach's sustainable development approach spans health and safety, environment, communities, human rights, and corporate social responsibility."
        image="/assets/page_13_img_2.jpeg"
        imageAlt="Tanker truck representing responsible logistics"
      />

      <section data-testid="sustainability-pillars-section" className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-10 lg:py-28">
        <Reveal className="mb-14 max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.32em] text-amber-400">Five commitments</p>
          <h2 className="mt-4 font-heading text-3xl font-bold sm:text-5xl">A base rock for operations, partnerships, and community trust.</h2>
        </Reveal>
        <div className="grid gap-6 lg:grid-cols-5">
          {SUSTAINABILITY_PILLARS.map((pillar, index) => {
            const Icon = icons[index];
            return (
              <Reveal key={pillar.key} delay={index * 0.07} className="group rounded-3xl border border-white/10 bg-[#0D131F] p-7 transition-all duration-500 hover:-translate-y-2 hover:border-blue-400/40">
                <Icon className="text-amber-400" size={28} />
                <p className="mt-10 font-mono text-xs text-blue-400">0{index + 1}</p>
                <h3 className="mt-3 font-heading text-2xl font-semibold" data-testid={`pillar-${pillar.key.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{pillar.key}</h3>
                <p className="mt-5 text-sm leading-7 text-slate-400">{pillar.text}</p>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section data-testid="environmental-focus-section" className="border-t border-white/10 bg-[#0D131F] px-4 py-24 sm:px-8 lg:px-10">
        <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
          <Reveal className="clip-frame h-[420px] overflow-hidden border border-white/10">
            <img src="/assets/page_11_img_2.jpeg" alt="Environmental services excavation equipment" className="h-full w-full object-cover" />
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-mono text-xs uppercase tracking-[0.32em] text-blue-400">Environmental protection</p>
            <h2 className="mt-4 font-heading text-3xl font-bold sm:text-5xl">Minimize footprint. Preserve the operating future.</h2>
            <p className="mt-6 text-base leading-8 text-slate-300">
              Exploration and production inevitably carry environmental impact. Clach's response is disciplined measurement, mitigation, and partnership with government and stakeholders across emissions, biodiversity, water, waste, energy efficiency, climate change, and supply chain decisions.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
